import { m } from 'framer-motion'
// @mui
import { styled } from '@mui/material/styles'
import { Box, Button, Container, Typography, Stack, Divider } from '@mui/material'
// components
import { Link as RouterLink } from 'react-router-dom'
import { MotionViewport, varFade } from '../../components/animate'

import Iconify from '../../components/iconify'
import { PATH_PAGE } from '../../routes/paths'
// ----------------------------------------------------------------------

const BACKGROUND_SOURCE = 'https://www.terminal49.com/images/bg-container.svg'

const StyledRoot = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(10, 0),
  [theme.breakpoints.up('md')]: {
    height: '50vh',
    padding: 0,
  },
  backgroundImage: `url(${BACKGROUND_SOURCE})`, // Add the background image source
  backgroundSize: 'cover', // Adjust as needed
  backgroundPosition: 'center', // Adjust as needed
  '&::after': {
    content: '""',
    position: 'absolute',
    left: 0,
    bottom: 0,
    right: 0,
    height: '10px',
    backgroundColor: '#fff',
  },
}))

// ----------------------------------------------------------------------

export default function HomeExcellence() {
  return (
    <StyledRoot sx={{}}>
      <Container component={MotionViewport}>
        <Box
          gap={{ xs: 3, lg: 5 }}
          sx={{
            outline: '0.01px transparent #fda92d',
            // Round the corners
            borderRadius: '10px',
            // Inner padding
            padding: '40px',
            // Reduce width
            width: '90%',
            // Align left
            margin: '0 auto',
            // Align left
            alignSelf: 'left',
          }}
          display="row"
          alignItems="left"
          gridTemplateColumns={{
            xs: 'repeat(1, 1fr)',
            md: 'repeat(3, 1fr)',
          }}
        >
          <Stack
            spacing={3}
            sx={{
              textAlign: 'left',
              mb: { xs: 2, md: 2 }, // Adjust the negative margin to your desired value
            }}
          >
            <m.div variants={varFade().inUp}>
              <Typography
                variant="h1"
                sx={{
                  textAlign: 'left',
                  lineHeight: '1.1em',
                  mt: 3,
                  pt: 0,
                  fontWeight: 50,
                  letterSpacing: '-0.04em',
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
                }}
              >
                Excellence, Delivered.
              </Typography>
            </m.div>
          </Stack>

          {/* Break Line with color */}

          <Divider orientation="horizontal" sx={{ my: 1, mx: 'auto', width: 950, height: 1 }} />

          <m.div variants={varFade().inUp}>
            <Typography
              variant="body2"
              sx={{
                textAlign: 'right',
                lineHeight: 1.3,
                pt: 0,
                mt: 2,
                fontWeight: 400,
                fontSize: 20,
                fontFamily:
                  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
              }}
            >
              We do more than ensure your load is delivered on time and on budget. We deliver a standard of service excellence unrivaled in
              the third-party logistics industry.
            </Typography>
          </m.div>

          <m.div variants={varFade().inUp}>
            <Typography
              variant="body2"
              sx={{
                textAlign: 'right',
                lineHeight: 1.3,
                pt: 0,
                mt: 2,
                fontWeight: 400,
                fontSize: 20,
                fontFamily:
                  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
              }}
            >
              Our success is driven by relationships. We build relationships for the long haul, from our shippers to our carriers, ensuring
              that our partners across the globe have access to reliable, predictable, and cost-effective 3PL services.
            </Typography>
          </m.div>

          <Stack spacing={1.5} direction={{ xs: 'column-reverse', sm: 'row' }} sx={{ my: 5 }} alignItems="left" justifyContent="flex-end">
            <m.div variants={varFade().inLeft} sx={{ display: 'flex' }}>
              <Button
                component={RouterLink}
                to={PATH_PAGE.about}
                size="small"
                variant="inherit"
                endIcon={<Iconify icon="ic:round-arrow-right-alt" width={24} />}
                sx={{
                  color: 'common.black',
                  transition: 'background-color 0.3s ease-in-out, color 0.3s ease-in-out',
                  '&:hover': {
                    color: 'primary.main',
                    transform: 'translateY(-5px)',
                    transition: 'transform 0.3s ease-in-out',
                  },
                }}
              >
                Our story
              </Button>
            </m.div>
          </Stack>
        </Box>
      </Container>
    </StyledRoot>
  )
}
